var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "q-composite-container" },
    [
      _c("div", { staticClass: "q-toolbar" }, [
        _c(
          "div",
          { staticClass: "q-toolbar-buttons" },
          [
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                style: _vm.firstButtonStyle,
                on: { click: _vm.newComposite },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "plus"] } })],
              1
            ),
            _vm._v(" "),
            _vm.getPermissions("DELETE")
              ? _c(
                  "q-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.hasSelection,
                        expression: "hasSelection",
                      },
                    ],
                    staticClass: "q-toolbar-btn",
                    on: {
                      click: function ($event) {
                        _vm.deleteDialog = true
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "trash"] },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.getPermissions("STRUCTURE")
              ? _c(
                  "q-button",
                  {
                    staticClass: "q-toolbar-btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.structureDialog = true
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "cog"] },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "q-input",
              {
                style: _vm.searchStyle,
                attrs: {
                  placeholder: this.$qt("listStructure.searchPlaceHolder"),
                },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              },
              [
                _c("q-button", {
                  attrs: {
                    slot: "append",
                    type: "info",
                    icon: "q-icon-search",
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "q-table",
        {
          staticClass: "q-composite-list",
          attrs: {
            stripe: "",
            data: _vm.filteredData,
            width: _vm.listStructure.width,
            "sum-text": "----",
            "empty-text": this.$qt("listStructure.emptyList"),
          },
          on: {
            "row-click": _vm.rowSelected,
            "selection-change": _vm.handleSelectionChange,
          },
        },
        [
          _c("q-table-column", { attrs: { type: "selection", width: "55" } }),
          _vm._v(" "),
          _c("q-table-column", { attrs: { label: "", width: "40" } }),
          _vm._v(" "),
          _vm._l(_vm.listStructure.columns, function (col) {
            return _c("q-table-column", {
              key: col.key,
              attrs: {
                type: col.type,
                sortable: col.sortable === true,
                label: col.caption,
                width: col.width === 0 ? undefined : col.width,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        col.fieldType === "DatePicker"
                          ? [
                              _c(
                                "span",
                                { staticStyle: { direction: "ltr" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getDate(scope.row[col.key]))
                                  ),
                                ]
                              ),
                            ]
                          : col.fieldType === "CheckBox"
                          ? [
                              scope.row[col.key] === true
                                ? _c("font-awesome-icon", {
                                    attrs: { icon: "check" },
                                  })
                                : _c("font-awesome-icon", {
                                    attrs: { icon: "times" },
                                  }),
                            ]
                          : col.fieldType === "model"
                          ? [_c("span", [_vm._v("AMIN")])]
                          : [_c("span", [_vm._v(_vm._s(scope.row[col.key]))])],
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.settingTitle"),
            width: "50%",
            visible: _vm.structureDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.structureDialog = $event
            },
          },
        },
        [
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateStructure },
                },
                [_vm._v(_vm._s(this.$qt("listStructure.confirmSetting")))]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.structureDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("listStructure.rejectSetting")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: _vm.detailDialogTitle,
            width: "50%",
            visible: _vm.detailDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialog = $event
            },
          },
        },
        [
          _c(
            "q-form",
            {
              ref: "compositeDetail",
              attrs: {
                model: _vm.currentModel,
                rules: _vm.compositeRules,
                "label-width": "150px",
              },
            },
            [
              _c("q-form-generator", {
                attrs: { "form-structure": _vm.compositeFormStructure },
                model: {
                  value: _vm.currentModel,
                  callback: function ($$v) {
                    _vm.currentModel = $$v
                  },
                  expression: "currentModel",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.detailDialog = false
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(this.$qt("actions.cancel")))])]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.persist(true)
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(this.$qt("actions.next")))])]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.persist(false)
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(this.$qt("actions.ok")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.settingTitle"),
            width: "50%",
            visible: _vm.structureDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.structureDialog = $event
            },
          },
        },
        [
          _c("div"),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateStructure },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.confirmSetting")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.structureDialog = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("listStructure.rejectSetting")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("model.deleteDialog.title"),
            visible: _vm.deleteDialog,
            width: "30%",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteDialog = $event
            },
          },
        },
        [
          _c("span", [
            _vm._v(_vm._s(this.$qt("model.deleteDialog.warningNote"))),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteModel()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("model.deleteDialog.confirm")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.deleteDialog = false
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(this.$qt("model.deleteDialog.cancel")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }